import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    cuentaCorriente: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    vendedor: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.cuentaCorriente = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.vendedor = null;
    },

    'INICIALIZAR_CUENTA_CORRIENTE' (state) {
        state.cuentaCorriente = [];
    },
    'SET_CUENTA_CORRIENTE' (state, cuentaCorriente) {
        state.cuentaCorriente = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        if (cuentaCorriente && cuentaCorriente.comprobantes) {
            state.cuentaCorriente = cuentaCorriente.comprobantes.map(item => ({
                ...item,
                _showDetails: false
            }))

            state.totalRegistros = cuentaCorriente.comprobantes.length;    
        }
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCuentaCorriente ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CUENTA_CORRIENTE');
            
            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.vendedor) {
                if (state.vendedor.id != 0) {
                    queryString += '&vendedorId=' + state.vendedor.id;
                }
            }
            
            apiAxios.get('vendedores/cuenta-corriente' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CUENTA_CORRIENTE', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getCuentaCorrienteByCobros ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CUENTA_CORRIENTE');
            
            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.vendedor) {
                if (state.vendedor.id != 0) {
                    queryString += '&vendedorId=' + state.vendedor.id;
                }
            }
            
            apiAxios.get('vendedores/cuenta-corriente/cobros' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CUENTA_CORRIENTE', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`presupuestosinternos/${params.presupuestoInternoId}/comisiones/cancelaciones/${params.vendedorComisionCancelacionId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    }    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}